module.exports = "<span *ngIf=\"model.dataType=='query'\">\n    {{value}}%\n </span>\n <span *ngIf=\"model.dataType=='selectedCity' || model.dataType =='cityToCompare'\">\n    <img src=\"assets/images/0{{value}}.png\" *ngIf=\"value==0 || value==1 || value==3|| value==4\"/>\n    <span *ngIf=\"value==2\">\n        לא רלוונטי\n     </span>\n </span>\n\n\n\n "


//////////////////
// WEBPACK FOOTER
// ./src/app/component/blocks/placeRow/placeRow.component.html
// module id = ./src/app/component/blocks/placeRow/placeRow.component.html
// module chunks = main